import get from 'lodash/get'
import Ajax from 'src/ajax'

const path = 'user'

/**
 * Actions
 */
const FETCH_REQUEST = `${path}/fetch-request`
const FETCH_REQUEST_SUCCESS = `${path}/fetch-success`
const FETCH_REQUEST_FAIL = `${path}/fetch-fail`
/**
 * Action Creators
 */

/**
 * Side Effects
 */
export const fetchList = (queries) => async (dispatch) => {
  dispatch({ type: FETCH_REQUEST })
  try {
    const options = {
      method: 'GET',
      url: path,
      params: queries,
    }
    const response = await Ajax(options)
    const list = response.data.users
    const total = response.data.total
    dispatch({ type: FETCH_REQUEST_SUCCESS, payload: { list, total } })
  } catch (error) {
    const error_text = get(error, 'response.data.error')
    // set fetching = false + error text
    dispatch({ type: FETCH_REQUEST_FAIL, payload: error_text })
  }
}

/**
 * Initial State
 */
const initialState = {
  fetching: false,
  list: [],
  total: 0,

  error: null,
}

/**
 * Reducer
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, fetching: true, error: null }
    case FETCH_REQUEST_SUCCESS:
      return {
        ...state,
        fetching: false,
        list: action.payload.list,
        total: action.payload.total,
      }
    case FETCH_REQUEST_FAIL:
      return { ...state, fetching: false, error: action.payload }

    default:
      return state
  }
}
